export default [
    {
        mode: 'narrow',
        query: '(max-width: 500px)'
    },
    {
        mode: 'medium',
        query: '(min-width: 501px) and (max-width: 900px)'
    },
    {
        mode: 'desktop',
        query: '(min-width: 901px)'
    }
]